import {UiTheme, UiThemeSize} from "@view/theme/types";
import {useMemo} from "react";
import {ukUA} from "@mui/material/locale";
import {createTheme} from "@mui/material";
import {buildThemeStyles} from "@view/theme/helpers/buildThemeStyles";

export function useGetThemeStyles({
                                      theme,
                                      forcedTheme,
                                      themeSize,
                                      forcedThemeSize,
                                  }: {
    theme: UiTheme,
    forcedTheme?: UiTheme,
    themeSize: UiThemeSize,
    forcedThemeSize?: UiThemeSize,
}) {
    return useMemo(() => {
        const themeStyles = buildThemeStyles({
            themeSize,
            theme,
            forcedTheme,
            forcedThemeSize,
        })
        return createTheme(themeStyles, ukUA)
    }, [theme, themeSize]);
}